document.addEventListener('turbo:load', () => {
  const expandableTitles = document.querySelectorAll('[data-expandable-title]');

  expandableTitles.forEach((container) => {
    const text = container.querySelector('[data-expandable-title-text]');
    const toggle = container.querySelector('[data-expandable-title-toggle]');
    if (!text || !toggle) return;

    container.classList.remove('program-breakdown-sub-selected-title--expanded');
    container.classList.remove('program-breakdown-sub-selected-title--clamped');
    toggle.classList.add('hidden');
    toggle.textContent = 'See more';

    const lineHeight = parseFloat(window.getComputedStyle(text).lineHeight) || 0;
    if (lineHeight <= 0) return;

    const maxHeight = lineHeight * 4;
    if (text.scrollHeight <= (maxHeight + 1)) return;

    container.classList.add('program-breakdown-sub-selected-title--clamped');
    toggle.classList.remove('hidden');

    toggle.onclick = () => {
      const expanded = container.classList.toggle('program-breakdown-sub-selected-title--expanded');
      container.classList.toggle('program-breakdown-sub-selected-title--clamped', !expanded);
      toggle.textContent = expanded ? 'See less' : 'See more';
    };
  });

  const modal = document.querySelector('[data-program-certificate-modal]');
  const openModalButton = document.querySelector('[data-open-certificate-modal]');
  if (!modal || !openModalButton) return;

  const closeModalButton = modal.querySelector('[data-close-certificate-modal]');
  const tierTabs = Array.from(modal.querySelectorAll('[data-certificate-tier-tab]'));
  const tierPanels = Array.from(modal.querySelectorAll('[data-certificate-tier-panel]'));
  const downloadLink = modal.querySelector('[data-certificate-download-link]');
  const shareButton = modal.querySelector('[data-certificate-share-link]');
  const activeTierInput = modal.querySelector('[data-certificate-active-tier]');

  const downloadUrlFor = (tier) => modal.querySelector(`[data-certificate-download-url="${tier}"]`)?.value || '#';
  const shareUrlFor = (tier) => modal.querySelector(`[data-certificate-share-url="${tier}"]`)?.value || '';

  const setActiveTier = (tier) => {
    activeTierInput.value = tier;

    tierTabs.forEach((tab) => {
      const tabTier = tab.dataset.certificateTierTab;
      const active = tabTier === tier;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    tierPanels.forEach((panel) => {
      const active = panel.dataset.certificateTierPanel === tier;
      panel.classList.toggle('hidden', !active);
    });

    if (downloadLink) {
      downloadLink.href = downloadUrlFor(tier);
    }
    if (shareButton) {
      shareButton.textContent = `Share ${tier.charAt(0).toUpperCase()}${tier.slice(1)} Certificate`;
    }
  };

  tierTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      if (tab.disabled) return;

      setActiveTier(tab.dataset.certificateTierTab);
    });
  });

  openModalButton.addEventListener('click', () => {
    modal.classList.remove('hidden');
    modal.showModal();
    setActiveTier(activeTierInput.value);
  });

  closeModalButton?.addEventListener('click', () => {
    modal.close();
    modal.classList.add('hidden');
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.close();
      modal.classList.add('hidden');
    }
  });

  modal.addEventListener('close', () => {
    modal.classList.add('hidden');
  });

  shareButton?.addEventListener('click', async () => {
    const tier = activeTierInput.value;
    const shareUrl = shareUrlFor(tier);
    if (!shareUrl) return;

    try {
      await navigator.clipboard.writeText(shareUrl);
      shareButton.textContent = 'Link Copied';
      window.setTimeout(() => setActiveTier(tier), 1200);
    } catch (_) {
      window.prompt('Copy this certificate link', shareUrl); // eslint-disable-line no-alert
    }
  });
});
